import { useBoostedGifs } from "queries";
import { IBoostedGifOptions } from "services/types";
import { boostHistory } from "utils/boostHistory";
import { useMemo } from "react";

export const useNewBoostedGifs = (options?: IBoostedGifOptions) => {
  const { data: boostedPostData } = useBoostedGifs(options);

  return useMemo(() => {
    const showedBoostedGifs = boostHistory.getCurrent();

    const boostedGifs = boostedPostData?.gifs.filter(gif => !showedBoostedGifs.includes(gif.id));

    return {
      boostedGifs: boostedGifs || [],
      boostedUsers: boostedPostData?.users || []
    };
  }, [boostedPostData]);
};
